import React, {useState} from 'react';
import 'contents/assets/scss/page/data.scss';
import Paging from '../../component/Inc/Paging';
import Upload from '../../component/Inc/Upload';
import Tab from '../../component/Inc/Tab';
import BtnLike from "../../component/Inc/BtnLike";//좋아요 버튼
function AnalysisExam() {
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '국어', value: 0},
    {title: '영어', value: 1},
    {title: '수학', value: 2},
    {title: '과탐', value: 3},
    {title: '사탐', value: 4},
    {title: '수시', value: 5}
  ];
  return (
    <main className="com_container p_analysis_exam">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu4_4">학교별 시험 분석</h2>
          <button className="com_btn orange s btn_plus">내용 등록</button>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top type_column">
              <div className="com_input_wrap">
                <select className="select xs">
                  <option value="년도 선택">년도 선택</option>
                </select>
                <select className="select xs">
                  <option value="학교지역 선택">학교지역 선택</option>
                </select>
                <select className="select xs">
                  <option value="학교명 선택">학교명 선택</option>
                </select>
                <select className="select xs">
                  <option value="학년 선택">학년 선택</option>
                </select>
                <select className="select xs">
                  <option value="학기 선택">학기 선택</option>
                </select>
              </div>
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <section className="com_board_search end">
                <div className="date_wrap">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <span className="divider"> ~ </span>
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                </div>
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="4%" />
                <col width="6%" />
                <col width="5%" />
                <col width="5%" />
                <col width="9%" />
                <col width="6%" />
                <col width="12%" />
                <col width="6%" />
                <col width="6%" />
                <col width="5%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>등록일</th>
                  <th>영역</th>
                  <th>과목</th>
                  <th>년도 학기</th>
                  <th>학교명</th>
                  <th>제목</th>
                  <th>파일</th>
                  <th>등록자</th>
                  <th>조회</th>
                </tr>
              </thead>
              <tbody>
                <tr className="selected">
                  <td>
                    <BtnLike/>
                  </td>
                  <td className="td_date">2022.08.25</td>
                  <td>국어</td>
                  <td>국어2</td>
                  <td>2022/고1/2학기 말</td>
                  <td>서울고등학교</td>
                  <td>서울고 2학기 중간고사</td>
                  <td>
                    <button className="btn_link blue">다운로드</button>
                  </td>
                  <td>
                    <button className="btn_link">홍길동103</button>
                  </td>
                  <td>123</td>
                </tr>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{10 - idx}</td>
                      <td className="td_date">2022.08.25</td>
                      <td>국어</td>
                      <td>국어2</td>
                      <td>2022/고1/2학기 말</td>
                      <td>서울고등학교</td>
                      <td>서울고 2학기 중간고사</td>
                      <td>
                        <button className="btn_link blue">다운로드</button>
                      </td>
                      <td>
                        <button className="btn_link">홍길동103</button>
                      </td>
                      <td>123</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Paging />
          </section>
          <section className="box">
            <div className="detail_tit dot">상세보기</div>
            <div className="com_info">
              <p className="name">홍길동104</p>
              <span className="dot" />
              <p className="date">2023.05.20 11:30</p>
              <div className="count">
                <p>
                  댓글 <span className="cnt">10</span>
                </p>
                <span className="dot" />
                <p>
                  조회 <span className="cnt">321</span>
                </p>
              </div>
            </div>
            <div className="com_input_wrap">
              <div className="sec_input select_box">
                <div className="com_btn_wrap">
                  <BtnLike/>
                  <button className="btn_edit"></button>
                  <button className="btn_delete"></button>
                </div>
              </div>
              <div className="com_board_box">
                <div className="board_item">
                  <div className="info center">
                    <div className="tit">영역, 과목 선택</div>
                    <div className="cont">
                      <div className="com_input_wrap">
                        <select className="select xs">
                          <option value="영역 선택">영역 선택</option>
                        </select>
                        <select className="select xs">
                          <option value="과목 선택">과목 선택</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="info center">
                    <div className="tit">년도 선택</div>
                    <div className="cont">
                      <div className="com_input_wrap">
                        <select className="select xs">
                          <option value="년도 선택">년도 선택</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="info center">
                    <div className="tit">학교 선택</div>
                    <div className="cont">
                      <div className="com_input_wrap flex_row">
                        <select className="select xs">
                          <option value="학교지역 선택">학교지역 선택</option>
                        </select>
                        <select className="select xs">
                          <option value="학교명 선택">학교명 선택</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="info center">
                    <div className="tit">학년 선택</div>
                    <div className="cont">
                      <div className="com_input_wrap">
                        <select className="select xs">
                          <option value="학년 선택">학년 선택</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="info center">
                    <div className="tit">학기 선택</div>
                    <div className="cont">
                      <div className="com_input_wrap">
                        <select className="select xs">
                          <option value="학기 선택">학기 선택</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="sec_input">
                  <input type="text" className="input" placeholder="제목 입력" />
                </div>
                <div className="board_item">
                  <div className="info">
                    <div className="tit">수업상세</div>
                    <div className="cont">발전, 정전기유도, 송전, 산화원</div>
                  </div>
                  <div className="info">
                    <div className="tit">난이도</div>
                    <div className="cont">
                      <div className="check">
                        <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                        <label htmlFor="rdo01">쉬움 (80점~)</label>
                        <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                        <label htmlFor="rdo02">보통 (60~70점)</label>
                        <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                        <label htmlFor="rdo03">어려움 (40~59점)</label>
                        <input type="radio" name="rdo" id="rdo04" className="com_chk circle" />
                        <label htmlFor="rdo04">매우어려움 (40미만)</label>
                      </div>
                    </div>
                  </div>
                  <div className="info">
                    <div className="tit">서술형</div>
                    <div className="cont">
                      <div className="check">
                        <input type="radio" name="rdo_1" id="rdo1_01" className="com_chk circle" />
                        <label htmlFor="rdo1_01">없음</label>
                        <input type="radio" name="rdo_1" id="rdo1_02" className="com_chk circle" />
                        <label htmlFor="rdo1_02">2~5문제</label>
                        <input type="radio" name="rdo_1" id="rdo1_03" className="com_chk circle" />
                        <label htmlFor="rdo1_03">6~9문제</label>
                        <input type="radio" name="rdo_1" id="rdo1_04" className="com_chk circle" />
                        <label htmlFor="rdo1_04">10문제 이상</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="editor">내용입력(에디터)</div>
              <div className="com_input_upload">
                <Upload title="파일 등록" className="com_btn gray s wl" />
                <div className="file">
                  <p className="file">
                    <span className="txt">File name.pdf</span>
                    <button type="button" className="btn_del_file" onClick={() => {}}></button>
                    <button type="button" className="btn_down" onClick={() => {}}></button>
                  </p>
                  <p className="file">
                    <span className="txt">File name.pdf</span>
                    <button type="button" className="btn_del_file" onClick={() => {}}></button>
                    <button type="button" className="btn_down" onClick={() => {}}></button>
                  </p>
                </div>
              </div>
              <hr className="com_divider" />
              <div className="com_btn_wrap center bottom">
                <button className="com_btn orange s">등록</button>
              </div>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
}

export default AnalysisExam;
